module.exports = __webpack_public_path__ + "img/explain_radio_white.ac30e42a.svg";